import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_pricing_scheme_list_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  label_type: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  obj_code: fromDatatype.VarcharDatatypeInterface;
  obj_option: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  param_code: fromDatatype.VarcharDatatypeInterface;
  param_name: fromDatatype.VarcharDatatypeInterface;
  param_type: fromDatatype.VarcharDatatypeInterface;
  param_option_json: fromDatatype.JsonDatatypeInterface;
  value_string: fromDatatype.VarcharDatatypeInterface;
  value_file: fromDatatype.VarcharDatatypeInterface;
  value_numeric: fromDatatype.NumericDatatypeInterface;
  value_datetime: fromDatatype.TimestampTzDatatypeInterface;
  value_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_fi_mst_pricing_scheme_list_hdr_RowClass implements bl_fi_mst_pricing_scheme_list_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  label_type: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  obj_code: fromDatatype.VarcharDatatypeInterface;
  obj_option: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  param_code: fromDatatype.VarcharDatatypeInterface;
  param_name: fromDatatype.VarcharDatatypeInterface;
  param_type: fromDatatype.VarcharDatatypeInterface;
  param_option_json: fromDatatype.JsonDatatypeInterface;
  value_string: fromDatatype.VarcharDatatypeInterface;
  value_file: fromDatatype.VarcharDatatypeInterface;
  value_numeric: fromDatatype.NumericDatatypeInterface;
  value_datetime: fromDatatype.TimestampTzDatatypeInterface;
  value_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
}